import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, MessageSquare, FileText, Briefcase, Sparkles, Users, Settings as SettingsIcon, LogOut, Globe } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { useLang } from "../../contexts/LanguageContext";

const AdminLayout = () => {
  const { logout, user } = useAuth();
  const { t, lang, setLang } = useLang();
  const nav = useNavigate();

  const items = [
    { to: "/admin", label: t.admin.nav.dashboard, icon: LayoutDashboard, end: true },
    { to: "/admin/messages", label: t.admin.nav.messages, icon: MessageSquare },
    { to: "/admin/blog", label: t.admin.nav.blog, icon: FileText },
    { to: "/admin/portfolio", label: t.admin.nav.portfolio, icon: Briefcase },
    { to: "/admin/services", label: t.admin.nav.services, icon: Sparkles },
    { to: "/admin/team", label: t.admin.nav.team, icon: Users },
    { to: "/admin/settings", label: t.admin.nav.settings, icon: SettingsIcon },
  ];

  return (
    <div className="grain" data-testid="admin-layout" style={{ minHeight: "100vh", display: "grid", gridTemplateColumns: "260px 1fr", background: "var(--rich-black)", color: "var(--warm-off-white)" }}>
      <aside style={{ padding: "32px 24px", background: "var(--rich-black-light)", borderRight: "1px solid rgba(139,32,53,0.25)", display: "flex", flexDirection: "column" }}>
        <Link to="/" className="font-display" style={{ fontSize: "1.75rem", fontWeight: 300, color: "var(--warm-off-white)", textDecoration: "none" }}>
          Vakar<span style={{ color: "var(--gold)" }}>.</span>
        </Link>
        <div className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.2em", color: "rgba(248,244,240,0.4)", textTransform: "uppercase", marginTop: 4 }}>Admin Panel</div>
        <nav style={{ marginTop: 48, display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase()}`}
              style={({ isActive }) => ({
                display: "flex", alignItems: "center", gap: 12,
                padding: "12px 14px", textDecoration: "none",
                color: isActive ? "var(--gold)" : "rgba(248,244,240,0.7)",
                background: isActive ? "rgba(201,151,58,0.08)" : "transparent",
                borderLeft: isActive ? "2px solid var(--gold)" : "2px solid transparent",
                fontSize: "0.9rem", transition: "all 0.3s var(--ease-cinema)",
              })}
            >
              <it.icon size={16} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ marginTop: "auto", paddingTop: 24, borderTop: "1px solid rgba(248,244,240,0.08)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16, fontSize: "0.8rem" }}>
            <Globe size={14} color="var(--gold)" />
            <button onClick={() => setLang("tr")} style={{ background: "transparent", border: "none", color: lang === "tr" ? "var(--gold)" : "rgba(248,244,240,0.5)", padding: 0, cursor: "pointer" }}>TR</button>
            <span style={{ color: "rgba(248,244,240,0.25)" }}>|</span>
            <button onClick={() => setLang("en")} style={{ background: "transparent", border: "none", color: lang === "en" ? "var(--gold)" : "rgba(248,244,240,0.5)", padding: 0, cursor: "pointer" }}>EN</button>
          </div>
          <p style={{ fontSize: "0.75rem", color: "rgba(248,244,240,0.5)", marginBottom: 12 }}>{user?.email}</p>
          <button data-testid="admin-logout" onClick={() => { logout(); nav("/admin/login"); }} className="font-mono" style={{ display: "flex", alignItems: "center", gap: 8, background: "transparent", border: "1px solid rgba(248,244,240,0.2)", color: "rgba(248,244,240,0.75)", padding: "10px 14px", cursor: "pointer", fontSize: "0.7rem", letterSpacing: "0.18em", textTransform: "uppercase", width: "100%", justifyContent: "center" }}>
            <LogOut size={14} /> {t.admin.logout}
          </button>
        </div>
      </aside>
      <main style={{ padding: "40px 48px", overflowY: "auto" }}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
